module.exports = __webpack_public_path__ + "img/首钢logo.500387f4.png";